import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const from = location.state?.from?.pathname || '/parent';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const user = await login(email, password);

      // Redirect based on role
      if (['super_admin', 'admin'].includes(user.role)) {
        navigate('/admin');
      } else if (user.role === 'parent') {
        navigate(from.startsWith('/parent') ? from : '/parent');
      } else {
        navigate('/');
      }
    } catch (err) {
      const status = err.response?.status;
      const serverError = err.response?.data?.error;
      if (status === 429) {
        setError('Too many login attempts. Please wait a minute and try again.');
      } else if (status === 423) {
        setError(serverError || 'Account temporarily locked. Please try again later.');
      } else {
        setError(serverError || 'Invalid email or password');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <img src="/logo.png" alt="Scribbles Learning Center" className="login-logo" />
          <h1>Parent Portal</h1>
          <p>Sign in to access your family's account</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="login-error">{error}</div>}

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your.email@example.com"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="login-links">
          <Link to="/forgot-password" className="forgot-link">
            Forgot your password?
          </Link>
        </div>

        <Link to="/" className="login-back">
          Back to Website
        </Link>
      </div>
    </div>
  );
};

export default Login;
